import React, { useState, useEffect } from 'react'
import { getContent, Paths } from '../firebase/database'
import { getParam } from '../utility'
import { useCodeStore } from '../brand'

export interface Dictionary<T> { [Key: string]: T }

export interface IStoreCode {
	state?: IState,
	checkCode?(code: string): void,
}

interface IState {
	hasValidCode: boolean,
	loading: boolean,
}

const StoreCode = React.createContext<IStoreCode>({})

export function StoreCodeContext(props) {
	const [state, set] = useState<IState>({
		hasValidCode: !useCodeStore,
		loading: false,
	})

	// Check if store exists and if its enabled.
	async function checkStoreCode(code: string): Promise<void> {
		set(p => ({ ...p, loading: true }))
		const store = (await getContent(`${Paths.codes}/${code}`)) as any

		const setHasValidCode = (value: boolean) => set(p => ({ ...p, hasValidCode: value }))

		if (store) setHasValidCode(!store.Disabled)
		else setHasValidCode(false)

		set(p => ({ ...p, loading: false }))
	}

	// On URL params change, check store code.
	useEffect(() => {
		const storeValueParam = getParam('code')
		if (storeValueParam) checkStoreCode(storeValueParam)
	}, [window.location.search])

	// Context value.
	const value: IStoreCode = {
		state,
		checkCode: checkStoreCode
	}

	return <StoreCode.Provider value={value}>{props.children}</StoreCode.Provider>
}

export default StoreCode
